import { ITeleportPreview } from '@interfaces/map';

const ORDINAL_SUFFIXES: Record<string, string> = {
  '1': '1st',
  '2': '2nd',
  '3': '3rd',
};

export const formatTeleportName = (teleportId: string): string => {
  return teleportId
    .replace(/_/g, ' ')
    .replace(/(\d+)\s*f$/gi, (_, num) => {
      const suffix = ORDINAL_SUFFIXES[num] || `${num}th`;
      return `${suffix} Floor`;
    })
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

export const resolveTeleportLocationId = (tp: ITeleportPreview): string =>
  tp.teleportLocation?.id ?? tp.id ?? tp.teleportId;

export const getTeleportTitle = (tp: ITeleportPreview): string => {
  const name = tp.name?.trim();
  if (name) {
    return name;
  }

  const id = resolveTeleportLocationId(tp);
  return formatTeleportName(id);
};

export const getTeleportTooltip = (tp: ITeleportPreview): string => {
  const description = tp.description?.trim();
  if (description) {
    return description;
  }

  return `Teleport to ${getTeleportTitle(tp)}`;
};
